export const defaults = {
  name: 'matterport',
  enabled: false,
  showHomeUrl: '',
};
